import React, { useState } from "react";
import { auth, googleProvider, db } from "../services/firebase";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  sendEmailVerification,
} from "firebase/auth";
import { ref, set, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { useAlert } from "./AlertContext";
import { getRedirectUrl, clearRedirectUrl, validateRedirectUrl } from "../utils/authRedirect";

import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
    const showAlert = useAlert();
  
  // Check if there's a redirect URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get('redirect');

  const handleInviteTracking = async (user) => {
    const invitedBy = localStorage.getItem("invitedBy");
    const userRef = ref(db, "users/" + user.uid);

    const userData = {
      name: user.displayName || "",
      email: user.email,
      username: user.email.split("@")[0],
      uid: user.uid,
      createdAt: new Date().toISOString(),
    };

    if (invitedBy) {
      userData.invitedBy = invitedBy;

      // Update inviter's count
      const inviterRef = ref(db, `invites/${invitedBy}`);
      const snap = await get(inviterRef);
      if (snap.exists()) {
        set(inviterRef, snap.val() + 1);
      } else {
        set(inviterRef, 1);
      }

      localStorage.removeItem("invitedBy");
    }

    await set(userRef, userData);
  };

  const loginWithEmail = async () => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const user = result.user;

      if (!user.emailVerified) {
        await sendEmailVerification(user);
        showAlert("⚠️ Please verify your email. A new verification link has been sent. Check your inbox or spam folder.", "info");
        return;
      }

      await handleInviteTracking(user);

      localStorage.setItem("user", JSON.stringify(user));
      // Dispatch custom event to notify App.js about user change
      window.dispatchEvent(new Event('userChanged'));
      showAlert("✅ Login Successful", "success");
      
      // Redirect to intended URL or dashboard
      const redirectUrl = validateRedirectUrl(getRedirectUrl());
      clearRedirectUrl();
      navigate(redirectUrl);
    } catch (err) {
      showAlert("❌ Login Failed: " + err.message, "error");
    }
  };

  const loginWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      await handleInviteTracking(user);

      localStorage.setItem("user", JSON.stringify(user));
      // Dispatch custom event to notify App.js about user change
      window.dispatchEvent(new Event('userChanged'));
      showAlert("✅ Google Login Successful", "success");
      
      // Redirect to intended URL or dashboard
      const redirectUrl = validateRedirectUrl(getRedirectUrl());
      clearRedirectUrl();
      navigate(redirectUrl);
    } catch (err) {
      showAlert("❌ Google login failed: " + err.message, "error");
    }
  };

  return (
    <div className="login-root">
      <div className="login-left">
        <div className="login-card">
          <div className="login-logo-row">
            <div className="login-logo">BAI</div>
            <span className="login-appname">BodhAI</span>
          </div>
          <h2 className="login-welcome">Welcome Back</h2>
          <p className="login-subtext">
            {redirectUrl ? "Sign in to access the test" : "Sign in to continue learning"}
          </p>
          <div className="login-input-group">
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="login-options-row">
            <label id="remember-me-label">
              <input type="checkbox" /> Remember me
            </label>
            <a href="/forgot-password" className="login-link">Forgot password?</a>
          </div>
          <button className="login-btn" onClick={loginWithEmail}>Sign In →</button>
          <div className="login-divider">Or continue with</div>
          <div className="login-social-row">
            <button className="login-social-btn" onClick={loginWithGoogle}>G</button>
            {/* Add more social buttons if needed */}
          </div>
          <div className="login-bottom-row">
            Don't have an account? <a href="/register" className="login-link">Sign up</a>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-showcase-card">
          <h2>Elevate Your Skills</h2>
          <p>Join thousands of learners mastering new skills with BodhAI</p>
          <div className="login-stats-row">
            <div className="login-stat">
              <div className="login-stat-value">10K+</div>
              <div className="login-stat-label">Students</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">100+</div>
              <div className="login-stat-label">Test Avaiable</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">98%</div>
              <div className="login-stat-label">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
